import React from "react"
import FontAwesome from "react-fontawesome"

export default function Legal() {
  return (
    <p className="legal">
      <small>
      <FontAwesome name="sitemap" size="lg" /> &nbsp;
      <FontAwesome name="credit-card" size="lg" /> &nbsp;
      <FontAwesome name="suitcase" size="lg" /> &nbsp;
      &copy; Aion Sigma</small>
    </p>  
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/Legal.js